import { FC } from "react";
import { t } from "i18next";
import { FaLock, FaMinus, FaPlus } from "react-icons/fa";

import { StepperProps } from "@models/shared/shared.model";

export const Stepper: FC<StepperProps> = ({
  disableDecrement,
  disableIncrement,
  isStepperDisabled = false,
  onDecrement,
  onIncrement,
  quantity,
}) => {
  return (
    <div className="fg-quantity-selector d-inline-flex align-items-center justify-content-center overflow-hidden bg-white">
      <button
        className="fg-qty-btn d-flex align-items-center justify-content-center"
        disabled={isStepperDisabled || disableDecrement}
        onClick={onDecrement}
      >
        <FaMinus />
      </button>
      <div className="fg-qty-value px-2 bg-white">
        <div className="d-flex align-items-center justify-content-center gap-1">
          {quantity}
          {isStepperDisabled && <FaLock className="fg-small-lock" />}
        </div>
        <span className="fg-qty-label">{t("qty")}</span>
      </div>
      <button
        className="fg-qty-btn d-flex align-items-center justify-content-center"
        disabled={isStepperDisabled || disableIncrement}
        onClick={onIncrement}
      >
        <FaPlus />
      </button>
    </div>
  );
};
